<template>
    <div class="col mainSearchContainer">
							<!-- search -->
							<div class="form-inline wp_SearchNavMainContainer">
								<search/>
							</div>
							<!-- search -->
						</div>
</template>
<script>
import Search from '@/components/widgets/search/Search'
export default {
	components: {
		Search
	}
}
</script>
